var RemoteDepdencyValidator =
/** @class */
function () {
  function RemoteDepdencyValidator() {}

  RemoteDepdencyValidator.prototype.Validate = function (item) {
    /* TODO re-enable once design of iTelemetryItem is finalized. Task used to track this:
     https://mseng.visualstudio.com/AppInsights/_workitems/edit/1310871
      // verify system properties has a ver field
    if (!item.sytemProperties ||
        !item.sytemProperties["ver"]) {
        return false;
    }
      if (!item.domainProperties ||
        !item.domainProperties["id"] ||
        !item.domainProperties["name"] ||
        !item.domainProperties["resultCode"] ||
        !item.domainProperties["duration"] ||
        !item.domainProperties["success"] ||
        !item.domainProperties["data"] ||
        !item.domainProperties["target"] ||
        !item.domainProperties["type"]) {
        return false;
    }
    */
    return true;
  };

  RemoteDepdencyValidator.RemoteDepdencyValidator = new RemoteDepdencyValidator();
  return RemoteDepdencyValidator;
}();

export { RemoteDepdencyValidator };